export const MuiLink = {
  styleOverrides: {
    root: {
      color: 'rgba(1, 128, 148, 1)',
      textDecoration: 'none',
      fontWeight: '700',
    },
  },
};
